<style lang="scss">
    .page-title {
        padding: 30px 40px 10px 40px;
        border-bottom:1px #d8d9df solid ;
        h2 {
            font-family: microsoft yahei;
            font-size:24px;
            color:#333333;
            font-weight: normal;

        }
    }
    .contract-box{
        padding:40px 30px;
        .contract-list{
            li{line-height:35px;}
            a{
                font-size:14px;
                color:#5078e6;
                text-decoration: underline;
            }
        }


    }
    .yrd-service{
        position:absolute;
        bottom:0;
        width:100%;
        margin-top:30px;
        text-align: center;
        img{
            width:180px;
        }

    }

</style>

<template>
    <div>
        <div class="page-title clearfix">
            <h2>合同列表</h2>
        </div>
        <div class="contract-box">
            <ul class="contract-list">
                <li  v-for="contract in contractList"><a href="javascript:;" @click="download(contract)">《{{contract.showName}}》下载</a></li>
            </ul>
        </div>

        <div v-if="capitalName=='XINWANG' || capitalName=='HUAXIA'" class="yrd-service"><img src="../../assets/images/service.png" alt=""></div>



    </div>
</template>
<script>
	import ContactsList from '../../components/contactsList.vue'
	export default {

		data() {
			return {
				capitalName:"",
				applyId:this.$route.params.applyId,
				contractList:[

				]
			}

		},
		components:{ContactsList},
		methods:{
			getContactList(){
				this.$axios({
					method: 'get',
					url: '/borrows/'+this.$route.params.applyId+'/contracts/list'
				}).then( (res) =>{
					console.log(res)
					this.contractList=res.data
					this.capitalName=res.data[0].capitalName
				}).catch(function (err) {
					console.warn(err)
				})
			},
			download(contract){
				_hmt.push(['_trackEvent', '点击事件', contract.showName]);
				let url = '/pcloan/api/borrows/'+this.$route.params.applyId+'/contracts/'+contract.fileType+'/download'
				window.location.href=url
			}
		},
		created(){
			this.getContactList()
			console.log('this.$route.params.applyId',this.$route.params.applyId)
		}
	}
</script>